import { useMemo } from "react";
import { useCrudItem } from "../../../toolympus/api/useSimpleCrud";
import { ProfileConfig } from "./typings";
import { FieldType, Schema } from "../../../toolympus/hooks/useSchema";
import { fieldtypeToSchemaType } from "../../../toolympus/components/ConfigurableForms/useConfigurableFormSubmissions";
import { cropText } from "../../../toolympus/components/primitives";
import { MaybeFieldDefinition } from "../../../toolympus/components/schemed";
import { useLoadedData } from "../../../toolympus/hooks/useLoadedData";

export const useAttendeeProfileConfiguration = () => {
  const data = useCrudItem<ProfileConfig>("/api/attendee/config", {
    defaultValue: {
      code: "",
      fields: [],
      display_name_format: "",

    },
  });

  return {
    ...data,
  }
}

export const schemaWithConfigurableFields = (baseSchema: Schema, fields: ProfileConfig["fields"], cfg?: { cropTitles?: boolean }) => {
  return fields.reduce<Schema>(
    (r,f) => {
        r[f._id] = {
            type: fieldtypeToSchemaType(f.fieldtype),
            label: cfg?.cropTitles ? cropText(f.title, 50) : f.title,
        }
        return r;
    },
    { ...baseSchema }
  );
}

export type AttendeeProfileConfigurationData = ReturnType<typeof useAttendeeProfileConfiguration>;

export const useAttendeeControls = (config: ProfileConfig) => {
  const [schema, fields] = useMemo(() => {
    const schema = schemaWithConfigurableFields({}, config.fields || []);

    const fields: MaybeFieldDefinition[] = config.fields.map(f => [f._id]);

    return [
      schema,
      fields,
    ]
  }, [config]);

  return {
    schema,
    fields,
  }
}


export const useAttendeeProfileConfig = () => {
  const config = useLoadedData<ProfileConfig>("/api/attendee/config", {
    code: "",
    fields: [],
    display_name_format: "",
  });

  const controls = useAttendeeControls(config.data);

  return {
    config: config.data,
    isLoading: config.isLoading,
    fields: controls.fields,
    simpleFields: controls.fields.filter(f => !!f && !!controls.schema[f[0]] && controls.schema[f[0]].type !== FieldType.bool),
    schema: controls.schema,
  }
}